import { captureMessage } from '@tink/core/src/sentry';
import { FC, useEffect } from 'react';
import { useAnalytics } from '../../../../../../../core/Analytics/AnalyticsProvider';
import { PageView } from '../../../../../../../models/analytics';

type Props = {
  templateType: string | null | undefined;
};

export const UnknownTemplateScreen: FC<Props> = ({ templateType }) => {
  const { tinklinkAnalytics } = useAnalytics();

  useEffect(() => {
    captureMessage('Missing template screen', {
      custom: {
        template: templateType || 'N/A',
      },
    });
    tinklinkAnalytics.sendViewEvent({ view: PageView.UNKNOWN_TEMPLATE_SCREEN });
  }, [templateType, tinklinkAnalytics]);

  return <div data-testid="unknown-template">Template screen not yet implemented</div>;
};
